import { SET_CASE_ID} from "./actionTypes";

export const setCaseId = (id) => {
    return  {
        type: SET_CASE_ID,
        payload: id
    }
    
}